import { MuiFileInput } from 'mui-file-input';
import React from 'react';

function UploadFile({ handleChange, value, titleName, className, }:any) {
  return (
    <div className={className}>
      {titleName && <h1>{titleName}</h1>}
      <MuiFileInput
        placeholder="Inventory File:"
        value={value}
        onChange={handleChange}
      />
    </div>
  );
}

export default UploadFile;
